export default "__VITE_ASSET__e70dba1b__"